/* ============================================
   ETÉREA — Animations & Interactions
   Landing Page V1 (Prelanzamiento)
   Vanilla JS — No dependencies
   ============================================ */

(function () {
  'use strict';

  /* ----------------------------------------
     1. SCROLL REVEAL (IntersectionObserver)
     ---------------------------------------- */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.eterea-reveal');
    if (!elements.length) return;

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (el) {
        el.classList.add('eterea-reveal--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('eterea-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------
     2. STICKY HEADER (hide/show on scroll)
     ---------------------------------------- */
  function initStickyHeader() {
    var header = document.querySelector('.eterea-header');
    if (!header) return;

    var lastScrollY = 0;
    var ticking = false;
    var scrollThreshold = 100;

    function updateHeader() {
      var currentScrollY = window.scrollY;

      // Toggle scrolled state (opaque background)
      if (currentScrollY > scrollThreshold) {
        header.classList.add('eterea-header--scrolled');
        header.classList.remove('eterea-header--on-hero');
      } else {
        header.classList.remove('eterea-header--scrolled');
        header.classList.add('eterea-header--on-hero');
      }

      // Hide on scroll down, show on scroll up
      if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
        header.classList.add('eterea-header--hidden');
      } else {
        header.classList.remove('eterea-header--hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Initial state
    if (window.scrollY <= scrollThreshold) {
      header.classList.add('eterea-header--on-hero');
    }
  }

  /* ----------------------------------------
     3. LAZY VIDEO PLAYBACK
     ---------------------------------------- */
  function initLazyVideo() {
    var videos = document.querySelectorAll('.eterea-hero__video');
    if (!videos.length) return;

    var poster = document.querySelector('.eterea-hero__poster');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            // Small delay to prioritize LCP
            setTimeout(function () {
              video.play().then(function () {
                // Fade out poster once video plays
                if (poster) {
                  poster.classList.add('eterea-hero__poster--hidden');
                }
              }).catch(function () {
                // Autoplay blocked — poster stays visible
              });
            }, 1000);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  /* ----------------------------------------
     4. KLAVIYO FORM HANDLER
     ---------------------------------------- */
  function initKlaviyoForms() {
    var forms = document.querySelectorAll('.eterea-klaviyo-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('.eterea-klaviyo-form__input');
        var submitBtn = form.querySelector('.eterea-klaviyo-form__submit');
        var successMsg = form.querySelector('.eterea-klaviyo-form__success');
        var errorMsg = form.querySelector('.eterea-klaviyo-form__error');
        var email = emailInput ? emailInput.value.trim() : '';
        var listId = form.getAttribute('data-klaviyo-list');
        var apiKey = form.getAttribute('data-klaviyo-api-key');
        var source = form.querySelector('input[name="source"]');
        var sourceValue = source ? source.value : 'landing_page_v1';

        // Reset messages
        if (successMsg) successMsg.hidden = true;
        if (errorMsg) errorMsg.hidden = true;

        // Basic email validation
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
          if (errorMsg) {
            errorMsg.textContent = 'Please enter a valid email address.';
            errorMsg.hidden = false;
          }
          return;
        }

        if (!listId || !apiKey) {
          if (errorMsg) {
            errorMsg.textContent = 'Form configuration error. Please try again later.';
            errorMsg.hidden = false;
          }
          return;
        }

        // Loading state
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('eterea-klaviyo-form__submit--loading');
        }

        // Klaviyo Subscribe API v2
        var url = 'https://a.klaviyo.com/api/v2/list/' + listId + '/subscribe';
        var payload = {
          api_key: apiKey,
          profiles: [
            {
              email: email,
              $source: sourceValue,
              landing_source: sourceValue,
            },
          ],
        };

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            if (response.ok || response.status === 200) {
              // Success
              if (successMsg) successMsg.hidden = false;
              if (emailInput) emailInput.value = '';
              form.classList.add('eterea-klaviyo-form--submitted');
            } else {
              throw new Error('Subscription failed');
            }
          })
          .catch(function () {
            if (errorMsg) {
              errorMsg.textContent = 'Something went wrong. Please try again.';
              errorMsg.hidden = false;
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('eterea-klaviyo-form__submit--loading');
            }
          });
      });
    });
  }

  /* ----------------------------------------
     INIT — Run on DOMContentLoaded
     ---------------------------------------- */
  function init() {
    initScrollReveal();
    initStickyHeader();
    initLazyVideo();
    initKlaviyoForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
